
const urlParams = new URLSearchParams(window.location.search);
const itemType = urlParams.get('type');

$("#gtin_grid_items:not(.read-only) .enable_gtin_level").change(function() {

    //if ($(this).is(':checked')) {
    var enabled = $(this).is(':checked');
    var row = $(this).closest("tr");
    var level = $(this).val();


    if (enabled) {
        row.addClass("enabled").removeClass('disabled');
        $("input[name='gtin_items["+level+"][level_id]']").val(level);
    } else {
        row.removeClass("enabled").addClass('disabled');
        $("input[name='gtin_items["+level+"][level_id]']").val("");
    }

    var init_class;
    if (abcsetup.item != undefined) {
        init_class = abcsetup.item.role ? abcsetup.item.role.class : '';

        var short_dated_prod = '';
        if (abcsetup.item.short_dated_prod && abcsetup.item.short_dated_prod.length) {
            short_dated_prod = abcsetup.item.short_dated_prod;
        }

        var dup_item = '';
        if (abcsetup.item.sap_item_number && abcsetup.item.sap_item_number.length) {
            dup_item = abcsetup.item.sap_item_number;
        }
    }
    else {
        init_class = '';
    }

    if ($(this).val() == 'pallet') {
        row.find("input[type='text'],input[type='number'],input[type='hidden'],select").each(function() {
            if (!enabled) {
                $(this).removeClass("form_error");
                if ($(this).hasClass("gtin_saleable_unit")) {
                    //$(this).rules( "remove", "checkSaleable");
                }

                if ($(this).hasClass("gtin_rfid_tag")) {
                    //$(this).rules( "remove", "checkRFIDTag");
                }

                if ($(this).hasClass("gtin_grid_gtin_14")) {
                    //$(this).rules("remove", "checkGtin14");
                    //$(this).rules("remove", "verifyUpcCheckDigit");
                }

                if ($(this).hasClass("gtin_qty")) {
                    //$(this).rules("remove", "validatePiecesQtyVal");
                    if ($(this).hasClass("readonly")) {
                        $(this).attr("readonly",false).removeClass("readonly");
                    }
                    if (!$(this).hasClass("invalid")) {
                        $(this).val("");
                        $(this).trigger("change");
                    }
                }

                $(this).attr("disabled",true);
                $(this).attr("required",false);
                if (!$(this).prop("readonly")) {
                    if ($(this).attr('type') != "hidden") {
                        $(this).val("");
                    }
                }

                $(this).closest("td").removeClass("required");
                $(this).siblings(".form_error").remove();

                try {
                    //$(this).valid();
                }
                catch(error) {}
            } else {
                $(this).attr("disabled", false);

                if ($(this).hasClass("gtin_grid_hibcc")) {
                    // nothing more to do for HIBCC
                    return;
                }

                if ($(this).attr('type') == "number") {
                    $(this).attr("required",true);
                    $(this).closest("td").addClass("required");
                }

                if ($(this).hasClass("gtin_saleable_unit")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        $(this).removeAttr("fieldValidate");
                        //$(this).rules("remove");
                    } else {
                        /*
                        $(this).rules('add', {
                            checkSaleable: true
                        });
                        */
                    }
                }

                if ($(this).hasClass("gtin_rfid_tag")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        $(this).removeAttr("fieldValidate");
                        //$(this).rules("remove");
                    } else {
                        /*
                        $(this).rules('add', {
                            checkRFIDTag: true
                        });
                        */
                    }
                }

                if ($(this).hasClass("gtin_grid_gtin_14")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        //$(this).rules("remove");
                    }
                    /*
                    $(this).rules('add', {
                        checkGtin14: true,
                        verifyUpcCheckDigit: true,
                    });
                    */
                }

                if ($(this).hasClass("gtin_qty")) {
                    // $(this).trigger('change');
                    /*
                    $(this).rules('add', {
                        validatePiecesQtyVal: true,
                    });
                    */
                }
            }
        });

    } else {
        var level_id = $(this).val();
        row.find("input[type='text'],input[type='number'],input[type='hidden'],select").each(function() {
            if (!enabled) {
                //$(this).removeClass("form_error");
                if ($(this).hasClass("gtin_saleable_unit")) {
                    //$(this).rules( "remove", "checkSaleable");
                }

                if ($(this).hasClass("gtin_rfid_tag")) {
                    //$(this).rules( "remove", "checkRFIDTag");
                }

                if ($(this).hasClass("gtin_grid_gtin_14")) {
                    //$(this).rules( "remove", "checkGtin14");
                    //$(this).rules( "remove", "verifyUpcCheckDigit");
                }

                if ($(this).hasClass("gtin_qty")) {
                    //$(this).rules("remove", "validatePiecesQtyVal");
                    if ($(this).hasClass("readonly")) {
                        $(this).attr("readonly",false).removeClass("readonly");
                    }

                    if (!$(this).hasClass("invalid")) {
                        $(this).val("");
                        $(this).trigger("change");
                    }
                }

                $(this).attr("disabled",true);
                $(this).attr("required",false);

                if (!$(this).prop("readonly")) {
                    if ($(this).attr('type') !== "hidden") {
                        $(this).val("");
                    }
                }

                $(this).closest("td").removeClass("required");
                window.fieldValidate.removeOrnaments(this);
                $(this).attr('required', false);
                //$(this).siblings(".form_error").remove();

                try {
                    $(this).valid();
                }
                catch(error) {}

            } else {
                $(this).attr("disabled",false);
                if ($(this).hasClass("gtin_grid_hibcc")) {
                    // nothing more to do for HIBCC
                    return;
                }

                // NOTE: Both gsmd roles are now gsmd_team
                if ((abcsetup.userRole.class == 'gsmd_team' && init_class == 'field_team') ||
                    abcsetup.userRole.class == 'asd_buyer' ||
                    abcsetup.userRole.class == 'sps_buyer' ||
                    (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                    (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                    (dup_item != '' && short_dated_prod == 'Y')) {
                        //$(this).rules("remove");

                } else {
                    $(this).attr("required",true);
                    //$(this).closest("div.form-group").addClass("required");
                    $(this).closest("td").addClass("required");
                }

                if ($(this).attr('type') != "hidden") {
                    if ((abcsetup.userRole.class == 'gsmd_team' && init_class == 'field_team') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).closest("td").removeClass("required");

                    } else {
                        $(this).attr('required', true);
                        //$(this).closest("div.form-group").addClass("required");
                        $(this).closest("td").addClass("required");
                    }

                    if (level_id == "item") {
                        if ($(this).hasClass("gtin_qty")) {
                            $(this).val(1).attr("readonly",true).addClass("readonly");
                            $(this).trigger("change");
                        }
                    }

                    if (level_id == "case" && abcsetup.userRole.class == "bessie_user") {
                        if ($(this).hasClass("gtin_qty")) {
                            $(this).val(1).trigger("change");
                        }
                    }
                }

                if ($(this).hasClass("gtin_saleable_unit")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        $(this).removeAttr("fieldValidate");
                        //$(this).rules("remove");
                    } else {
                        /*
                        $(this).rules('add', {
                            checkSaleable: true
                        });
                        */
                    }
                }

                if ($(this).hasClass("gtin_rfid_tag")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        $(this).removeAttr("fieldValidate");
                        //$(this).rules("remove");
                    } else {
                        /*
                        $(this).rules('add', {
                            checkRFIDTag: true
                        });
                        */
                    }
                }

                if ($(this).hasClass("gtin_grid_gtin_14")) {
                    if (abcsetup.userRole.class == 'asd_buyer' ||
                        abcsetup.userRole.class == 'ahp_cm' ||
                        abcsetup.userRole.class == 'bluepoint_cm' ||
                        abcsetup.userRole.class == 'sps_buyer' ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                        (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer') ||
                        (dup_item != '' && short_dated_prod == 'Y')) {
                        // $(this).siblings('.input_required_indicator').remove();
                        $(this).removeClass("required");
                        $(this).closest("td").removeClass("required");
                        //$(this).rules("remove");
                    }

                    /*
                    $(this).rules('add', {
                        checkGtin14: true,
                        verifyUpcCheckDigit: true,
                    });
                    */
                }

                if ($(this).hasClass("gtin_qty")) {
                    // $(this).trigger('change');
                    /*
                    $(this).rules('add', {
                        validatePiecesQtyVal: true,
                    });
                    */
                }

                if ($(this).hasClass("mgf")) {
                    if ((abcsetup.userRole.class != 'gsmd_team' && init_class != 'oncology_cm') ||
                        (abcsetup.userRole.class != 'gsmd_team' && init_class != 'bessie_user')) {

                        $(this).attr("required", false);
                        $(this).closest("div.form-group").addClass("required");
                    }
                }

                if (abcsetup.userRole.class == 'bluepoint_cm' ||
                    abcsetup.userRole.class == 'ahp_cm' ||
                    abcsetup.userRole.class == 'asd_buyer' ||
                    abcsetup.userRole.class == 'sps_buyer' ||
                    (abcsetup.userRole.class == 'gsmd_team' && init_class == 'asd_buyer') ||
                    (abcsetup.userRole.class == 'gsmd_team' && init_class == 'sps_buyer')) {
                    if ($(this).hasClass("gtin_bar_code")) {
                        $(this).attr("required", false);
                        $(this).closest("td").removeClass("required");
                    }
                }
            }
        });
    }

    // Make the MGF field required if the user has specified a GTIN-14 or HIBCC
    if (row.find('input.gtin_grid_gtin_14').val() !== '' || row.find('input.gtin_grid_hibcc').val() !== '') {
        row.find('select.mgf').attr('required', true);
    }
}).trigger("change");

$("#gtin_grid_items:not(.read-only) .gtin_saleable_unit").on('change', function() {
    // Reset all saleable drop downs
    $(".gtin_saleable_unit").each(function() {
        $(this)[0].setCustomValidity("");
        fieldValidate.removeOrnaments($(this));
    });

    // Find any selected options that are Y
    if ($('.gtin_saleable_unit:not(disabled) option:selected[value="Y"]').length == 0) {
        $(this)[0].setCustomValidity("Select at least one level as a saleable unit");
    }
});

$("#gtin_grid_items:not(.read-only) .gtin_rfid_tag").on('change', function() {
    // Reset all rfid drop downs
    $(".gtin_rfid_tag").each(function() {
        $(this)[0].setCustomValidity("");
        fieldValidate.removeOrnaments($(this));
    });
});

$("#gtin_grid_items:not(.read-only) .gtin_qty").change(function() {
    var row_level = $(this).attr("name") ? $(this).attr("name").match(/gtin_items\[(.*)\]\[(.*)\]/) : '';
    var value = $(this).val();
    if (row_level[1] == 'inner') {
        if (value != "") {
            $("#pack_pieces").val(value);
        }

        if (value != "") {
            $("#pack_pieces").attr("readonly",true).addClass("readonly");
        } else {
            $("#pack_pieces").attr("readonly",false).removeClass("readonly");
        }

    } else {
        if (value != "") {
            $("#"+row_level[1]+"_pieces").val(value);
        }

        if (value != "") {
            $("#"+row_level[1]+"_pieces").attr("readonly",true).addClass("readonly");
        } else {
            $("#"+row_level[1]+"_pieces").attr("readonly",false).removeClass("readonly");
        }
    }
});

$(document).ready(function () {
   $("#gtin_grid_items:not(.read-only) .gtin_saleable_unit").trigger("change");

   $("#gtin_grid_items:not(.read-only) .gtin_rfid_tag").trigger("change");

   $("#gtin_grid_items:not(.read-only) .gtin_grid_gtin_14, #gtin_grid_items:not(.read-only) .gtin_grid_hibcc").change(function() {
        var row = $(this).closest("tr");

        // Make the MGF field required if the user has specified a GTIN-14 or HIBCC
        if (row.find('input.gtin_grid_gtin_14').val() !== '' || row.find('input.gtin_grid_hibcc').val() !== '') {
            row.find('select.mgf').attr('required', true);
        } else {
            row.find('select.mgf').attr('required', false);
        }

        /*
        $(this).rules('add', {
            checkGtin14: true,
            verifyUpcCheckDigit: true,
        });
        */
   }).trigger("change");

   $("#gtin_grid_items:not(.read-only) .enable_gtin_level").trigger("change");
});


// Rx AHP Category Manager - Non Rx Items
if (abcsetup.userRole.class == 'ahp_cm' && itemType == 'otg') {
    gtin14IsNotRequired();
    saleableUnitRequiredForAtLeastOneLevel();
}

function gtin14IsNotRequired() {
    $("#gtin_grid_items .enable_gtin_level").on('change', function() {
        $('.gtin_grid_gtin_14').attr('required', false);
    });
}

function saleableUnitRequiredForAtLeastOneLevel() {
    // Wrapped in document.ready due to change events firing on load.
    $(document).ready(function() {
        $("#gtin_grid_items .enable_gtin_level").on('change', function() {
            let $selected = $("#gtin_grid_items .enable_gtin_level:checked");

            // If only one level is selected, mark it as saleable and don't allow the user to change it
            if ($selected.length == 1) {
                $(this).closest('tr').find('td select.gtin_saleable_unit').val('Y').prop('disabled', true);
            }

            // If the user selects more than one level, allow the user to update the saleable select
            if ($selected.length >= 2) {
                $selected.closest('tr').find('td select.gtin_saleable_unit').prop('disabled', false);
            }
        });

        $(".gtin_saleable_unit").on('change', function() {
            let saleableCount = $('.gtin_saleable_unit').filter(function() {
                return $(this).val() === 'Y'
            }).length;


            // Don't allow user to change all saleable dropdowns to 'N'
            if (saleableCount === 0) {
                $(this).val('Y');
                alert('At least one level must be marked as a saleable unit');
            }
        });
    })
}
